{
  "alert.informative": "Informativ",
  "alert.negative": "Negativ",
  "alert.notice": "Meddelelse",
  "alert.positive": "Positiv",
  "attachmentlist.nextAttachments": "Vis næste vedhæftede filer",
  "attachmentlist.previousAttachments": "Vis tidligere vedhæftede filer",
  "chat.newMessage": "Ny besked",
  "chat.scrollToBottom": "Rul ned til bunden",
  "messagefeedback.thumbDown": "Dårligt svar",
  "messagefeedback.thumbUp": "Godt svar",
  "promptfield.aiDisclaimer": "Svar genereres ved hjælp af AI og kan være upræcise. Kontrollér oplysningerne før brug.",
  "promptfield.aiUserGuidlines": "Retningslinjer for AI-brugere",
  "promptfield.attachments": "Vedhæftede filer",
  "promptfield.insertButton": "Tilføj",
  "promptfield.label": "Prompt",
  "promptfield.placeholder": "Er du klar til at komme i gang? Stil et spørgsmål, del en idé, eller tilføj en opgave.",
  "promptfield.placeholder.small": "Spørg om hvad som helst",
  "promptfield.stopButton": "Stop",
  "promptfield.submitButton": "Send",
  "promptfield.uploading": "Uploader",
  "responsestatus.loading": "Indlæser",
  "responsestatus.processing": "Behandler…",
  "voicebutton.startListening": "Start optagelse",
  "voicebutton.stopListening": "Stop optagelse"
}
